import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "pp-ticket-check__button-wrapper" }
const _hoisted_2 = {
  class: "ds-tooltip__content pp-confirm-button__popper",
  role: "tooltip"
}
const _hoisted_3 = ["innerHTML"]

import { computed, onMounted, ref } from "vue";
import Popper from "vue3-popper";
import { LotteryParser } from "@sazka/lotteries/js/utils/lottery-parser";
import { getLotteryConfig } from "@sazka/lotteries/js/utils/lottery-configs/get-lottery-config";
import { usePpWagerConfiguration } from "./composables/use-wager-configuration";
import { usePpTicketCheck } from "./composables/use-ticket-check";
import PpConfirmButton from "./components/pp-confirm-button.vue";
import PpTicketCheckResults from "./components/ticket-check/pp-ticket-check-results.vue";
import PpWagerEditorComponent from "./components/pp-wager-editor-component.vue";
import { usePpWagerValidator } from "./composables/use-wager-validator";


export default /*@__PURE__*/_defineComponent({
  __name: '_pp-ticket-check',
  props: {
    lottery: {}
  },
  setup(__props: any) {

const props = __props;

const lottery = computed(() => LotteryParser.parseLotteryName(props.lottery));

const { setTicketCheck, ticketCheckResult } = usePpTicketCheck();
setTicketCheck(true);

onMounted(() => {
    // CLS fix
    const root = document.getElementById("pp-ticket-check");
    root.classList.add("loaded");
});

const config = getLotteryConfig(lottery.value);
usePpWagerConfiguration().configure(config);

const { isTicketCheckValid, errorMessage } = usePpWagerValidator();

const isDisabled = computed(() => !isTicketCheckValid.value);
const showPopper = ref(false);
const popperVisible = computed(() => showPopper.value && isDisabled.value);

const handleClick = async () => {
    if (isDisabled.value) {
        showPopper.value = true;
        setTimeout(() => {
            showPopper.value = false;
        }, 3000);
    } else {
        await usePpTicketCheck().getTicketCheckResult();
    }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(PpWagerEditorComponent),
    _createVNode(_unref(Popper), {
      show: popperVisible.value,
      arrow: true,
      placement: "top",
      class: "ds-tooltip",
      locked: true,
      "offset-distance": "-2",
      "z-index": "300"
    }, {
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", { innerHTML: _unref(errorMessage) }, null, 8, _hoisted_3)
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(PpConfirmButton, {
            onClick: handleClick,
            "is-disabled": isDisabled.value,
            "data-test": "button-check-ticket"
          }, {
            default: _withCtx(() => _cache[0] || (_cache[0] = [
              _createTextVNode(" Zkontrolovat sázku ")
            ])),
            _: 1,
            __: [0]
          }, 8, ["is-disabled"])
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    (_unref(ticketCheckResult))
      ? (_openBlock(), _createBlock(PpTicketCheckResults, { key: 0 }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})